import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './Analytics';

/**
 * Компонент для отслеживания смены страниц
 * Отправляет событие просмотра страницы при каждом изменении URL
 */
const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Отправляем событие просмотра страницы
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

export default PageTracker;
